import { inject, Injectable } from '@angular/core';
import { QuoteToolStrategyService } from '@lx/quote-tool/shared/services';
import { QuoteToolPreselectedModes } from '@lx/shared/utils';
import { Observable, of } from 'rxjs';
import { RouteIds } from '../../../types';
import { QuoteToolLiteStore } from '../../../store';

@Injectable({
  providedIn: 'root',
})
export class DefaultModeStrategyService implements QuoteToolStrategyService<RouteIds> {
  private readonly qtLiteStore = inject(QuoteToolLiteStore);

  getQuoteToolMode(): QuoteToolPreselectedModes {
    return QuoteToolPreselectedModes.default;
  }

  getStepToNavigate(): Observable<RouteIds> {
    return this.qtLiteStore.currentStepId$;
  }

  loadData$(): Observable<boolean> {
    // The default one has nothing to load
    return of(true);
  }
}
